import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isset } from '@cawita/core-front';
import { CwtLanguageService } from './language.service';
import { isValid } from 'date-fns';

@Pipe({
  name: 'localeDate',
  pure: false
})
export class LocaleDatePipe implements PipeTransform {
  constructor(private language: CwtLanguageService) { }

  transform(value: Date | string | number, format?: string): string | null {
    if (!isset(value)) return '';
    value = new Date(value);
    if (!isValid(value)) return '';
    return formatDate(value, format, this.language.localeId);
  }

}
